// apps/website/src/config/webapp.ts

const PROD_WEBAPP_URL = "https://app.orrakingdom.com";
const DEV_WEBAPP_URL = "http://localhost:3005";

function isLocalHost(host: string): boolean {
  return (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "0.0.0.0" ||
    /^192\.168\./.test(host) ||
    /^10\./.test(host) ||
    /^172\.(1[6-9]|2[0-9]|3[01])\./.test(host)
  );
}

function isLocalhostUrl(url: string): boolean {
  try {
    return isLocalHost(new URL(url).hostname);
  } catch {
    return false;
  }
}

function resolveWebappUrl(): string {
  // 1. Runtime hostname detection (browser only; no SSR in this app)
  if (typeof window !== "undefined" && window.location) {
    const currentHost = window.location.hostname;

    if (isLocalHost(currentHost)) {
      return DEV_WEBAPP_URL;
    }

    // We're on a deployed host. Trust a non-localhost env override if
    // one was baked in; otherwise use the production default.
    const configured = process.env.REACT_APP_WEBAPP_URL;
    if (configured && configured.length > 0 && !isLocalhostUrl(configured)) {
      return configured.replace(/\/$/, "");
    }

    return PROD_WEBAPP_URL;
  }

  // 2. Non-browser fallback (SSR / tests / prerender)
  const configured = process.env.REACT_APP_WEBAPP_URL;
  if (configured && configured.length > 0) {
    return configured.replace(/\/$/, "");
  }
  return process.env.NODE_ENV === "production"
    ? PROD_WEBAPP_URL
    : DEV_WEBAPP_URL;
}

export const WEBAPP_URL: string = resolveWebappUrl();

export const webappUrl = (path: string): string =>
  `${WEBAPP_URL}${path.startsWith("/") ? path : `/${path}`}`;
